<div class="flex flex-col w-full">
  @if (label()) {
    <label
      [attr.for]="chipInput.id"
      class="text-ts-input-label-size text-ts-input-label font-ts-input-label-weight leading-ts-input-label"
    >
      {{ label() }}
    </label>
  }

  <div
    class="ts-chip-autocomplete"
    [ngClass]="{
      focused: isFocused,
    }"
  >
    <mat-chip-grid #chipGrid class="w-full" [attr.aria-label]="label()">
      @for (item of selectedItems(); track getUniqueValue(item)) {
        <mat-chip-row [class.invalid]="!validateItem()(item)" [removable]="!disabled()" (removed)="removeItem(item)">
          {{ getChipDisplayValue(item) }}
          @if (!validateItem()(item)) {
            <mat-icon class="warning-icon">warning</mat-icon>
          }
          @if (!disabled()) {
            <button matChipRemove [attr.aria-label]="'Remove ' + getChipDisplayValue(item)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-chip-row>
      }
    </mat-chip-grid>

    <input
      #chipInput="matChipInput"
      [placeholder]="placeholder()"
      [attr.data-testid]="testId()"
      [formControl]="searchControl"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="mode() === 'autocomplete' ? [] : separatorKeys()"
      [matAutocomplete]="auto"
      [matAutocompleteDisabled]="mode() === 'manual'"
      (matChipInputTokenEnd)="onTokenEnd($event)"
      (focus)="isFocused = true"
      (blur)="onBlur()"
    />

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
      @for (item of filteredItems$ | async; track getUniqueValue(item)) {
        <mat-option [value]="item">
          {{ getDisplayValue(item) }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>

  @if (hasInvalidItems() && invalidItemMessage()) {
    <p class="mb-1 text-sm text-danger mt-1">
      {{ invalidItemMessage() }}
    </p>
  } @else if (hint()) {
    <span class="text-xs text-gray-500 mt-1">{{ hint() }}</span>
  }
</div>
